import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseResizableComponent } from '@src/app/modules/base';

@Component({
  selector: 'lp-category-header',
  templateUrl: './category-header.component.html',
  styleUrls: ['./category-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CategoryHeaderComponent extends BaseResizableComponent {
  @Input() title?: string;
  @Output() back = new EventEmitter<void>();
}
